import amiriFontUrl from '../../fonts/Amiri-Regular.ttf';
import amiriFontBoldUrl from '../../fonts/Amiri-Bold.ttf';
import lateefFontUrl from '../../fonts/Lateef.ttf';
import lateefFontBoldUrl from '../../fonts/Lateef-Bold.ttf';
import aeCortobaFontUrl from '../../fonts/AeCortoba.ttf';

export const scoreSheetFonts = [
  {
    url: aeCortobaFontUrl,
    fileName: 'AeCortoba.ttf',
    fontName: 'AeCortoba',
    weight: 'normal',
  },
  {
    url: lateefFontUrl,
    fileName: 'Lateef.ttf',
    fontName: 'Lateef',
    weight: 'normal',
  },
  {
    url: lateefFontBoldUrl,
    fileName: 'Lateef-Bold.ttf',
    fontName: 'Lateef-Bold',
    weight: 'bold',
  },
  {
    url: amiriFontUrl,
    fileName: 'Amiri-Regular.ttf',
    fontName: 'Amiri',
    weight: 'normal',
  },
  {
    url: amiriFontBoldUrl,
    fileName: 'Amiri-Bold.ttf',
    fontName: 'Amiri-Bold',
    weight: 'bold',
  },
];
